export default {
    required: true,
    default: '',
    type: '' as any as () => string,
};
